import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import ButtonWithLoading from "../../../components/ButtonWithLoading";
import { getTranslation } from "../../../heplers/translationHelper";
import { Post } from "../../../actions";
import { useSnackbar } from "notistack";


export default function SubscriptionDialog({ id, packageType,onNotice, open, onClose }) {
  const [currentPlan, setCurrentPlan] = useState( "free" ); 
  const [isSubmitting, setIsSubmitting] = useState( false ); 
      const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setCurrentPlan(packageType === 0 ? "free" : "premium");
    setSelectedPlan(packageType === 0 ? "free" : "premium");
  },[packageType]);
  // "free" | "premium" | "notice"

  const [selectedPlan, setSelectedPlan] = useState("free");

//   const handleConfirm = () => {
//     if (currentPlan === "premium" && selectedPlan === "free") {
//       // Cancel subscription → move to notice period
//       setCurrentPlan("notice");
//     } else {
//       setCurrentPlan(selectedPlan);
//     }
//     onClose();
//   };

  const getStatusChip = () => {
    switch (currentPlan) {
      case "premium":
        return <Chip label={getTranslation("Premium Active")} color="success" />;
      case "free":
        return <Chip label={getTranslation("Free Plan")} />;
      case "notice":
        return <Chip label={getTranslation("Notice Period Active")} color="warning" />;
      default:
        return null;
    }
  };

    const handleChangeSubscription = () => {
        setIsSubmitting(true);
        Post(
            { id: id, packageType: selectedPlan === "free" ? 0 : 1 },
            "/restaurant/ChangeRestaurantSubscription", null, resp => {
                enqueueSnackbar(
                    getTranslation(
                        "Subscription updated successfully",
                        "Subscription updated successfully",
                        "Subscription updated successfully"
                    ),
                    {
                        variant: "success",
                    }
                );
                onClose();
        setIsSubmitting(false);

            }, error => {
                setIsSubmitting(false);
            })
    }

     const handleCancelSubscription = () => {
        setIsSubmitting(true);
        Post(
            { id: id},
            "/restaurant/CancelNoticePeriod", null, resp => {
                enqueueSnackbar(
                    getTranslation(
                        "Subscription updated successfully",
                        "Subscription updated successfully",
                        "Subscription updated successfully"
                    ),
                    {
                        variant: "success",
                    }
                );
                onClose();
        setIsSubmitting(false);

            }, error => {
                setIsSubmitting(false);
            })
    }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{getTranslation("Manage Subscription")}</DialogTitle>

      <DialogContent>
        <Box mb={2}>{getStatusChip()}</Box>

        {currentPlan === "notice" && (
          <Alert severity="info" sx={{ mb: 2 }}>
            {getTranslation("Your subscription has been cancelled. You are currently in your notice period and will be downgraded to Free after it ends.")}
          </Alert>
        )}

        <Typography variant="subtitle1" gutterBottom>
          {getTranslation("Choose your plan:")}
        </Typography>

        <RadioGroup
          value={selectedPlan}
          onChange={(e) => setSelectedPlan(e.target.value)}
           // Disable changes during notice period
        >
          <FormControlLabel
            value="free"
            control={<Radio />}
            label={
              <Box>
                <Typography>{getTranslation("All In Plan")}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {getTranslation("Included in all in package")}
                </Typography>
              </Box>
            }
            disabled={currentPlan === "notice"}
          />

          <FormControlLabel
            value="premium"
            control={<Radio />}
            label={
              <Box>
                <Typography>{getTranslation("Subscription Plan ( €1 /month)")}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {getTranslation("Stand alone subscription")}
                </Typography>
              
              </Box>
            }
          />
        </RadioGroup>

        {currentPlan === "premium" && selectedPlan === "free" && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {getTranslation("Cancelling your Premium subscription will start your notice period. You will retain Premium access until the period ends.")}
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{getTranslation("Cancel")}</Button>
         {onNotice !=null && (
          <ButtonWithLoading
            type="submit"
            loading={isSubmitting}
            onClick={handleCancelSubscription}
            title={getTranslation("Cancel Notice", "Cancel Notice", "Cancel Notice")}
            variant="contained"
            color="primary"
            textColor="white"
          />
        )}
        {
          onNotice == null && currentPlan === "premium" && (
             <ButtonWithLoading
                  type="submit"
                  loading={isSubmitting}
                  onClick={handleChangeSubscription}
                  title={getTranslation("Cancel Plan", "Cancel Plan", "Cancel Plan")}
                  variant="contained"
                  color="primary"
                  textColor="white"
                  disabled={isSubmitting}

              />)
        }
        
              <ButtonWithLoading
                  type="submit"
                  loading={isSubmitting}
                  onClick={handleChangeSubscription}
                  title={getTranslation("Change Plan", "Change Plan", "Change Plan")}
                  variant="contained"
                  color="primary"
                  textColor="white"
                  disabled={selectedPlan === currentPlan || isSubmitting}

              />
        
        {/* <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={selectedPlan === currentPlan}
        >
          Confirm
        </Button> */}
      </DialogActions>
    </Dialog>
  );
}